<template>
  <b-overlay :show="loading" rounded="sm">
    <b-card>
      <b-card-text>
        <h2 class="title font-weight-bold text-uppercase">Frete terceirizado</h2>
        <b-row class="mt-4">
          <transition name="slide-fade">
            <b-col cols="12" class="mb-4" v-if="!fields.enabled">
              <img width="100%" src="@/assets/img/melhor-envio/banner.png" />
            </b-col>
          </transition>
          <b-col cols="12" class="d-flex align-items-center">
            <span> Quer vender fora da sua área de atuação? </span>
            <b-form-checkbox
              :disabled="isPermissionClerk"
              switch
              class="ml-3"
              v-model="fields.enabled"
              @change="fields.integration.id ? update({}) : save()"
            />
            <span class="fs-14" v-if="fields.integration.id">
              ({{ getText(fields.integration.status) }})
            </span>
          </b-col>
          <b-col
            cols="12"
            class="mt-4"
            v-if="
              fields.enabled &&
              fields.integration.status ===
                ENABLED_INTEGRATION_STATUS.WAITING_USER_ACTION
            "
          >
            <b-alert show variant="warning">
              Para que seja possível calcular o frete, realizar o envio e
              rastreio dos produtos da sua loja pelo seu aplicativo é necessário
              ter um cadastro na plataforma do
              <a
                href="https://melhorenvio.com.br"
                target="_blank"
                rel="noopener noreferrer"
                :disabled="isPermissionClerk"
              >
                Melhor Envio,
              </a>
              <a
                href="https://melhorenvio.com.br/cadastre-se"
                target="_blank"
                rel="noopener noreferrer"
              >
                clique aqui
              </a>
              para realizar seu cadastro.

              <div class="mt-2">
                <b-btn
                  :disabled="isPermissionClerk"
                  size="sm"
                  variant="success"
                  id="confirmRegistryButton"
                  @click="showRegistryConfirmation = true"
                >
                  <i class="fas fa-check mr-2"></i>
                  Já realizei o meu cadastro
                </b-btn>
              </div>
            </b-alert>
          </b-col>
          <b-col
            cols="12"
            class="mt-4"
            v-if="
              fields.enabled &&
              fields.integration.status ===
                ENABLED_INTEGRATION_STATUS.WAITING_AUTHORIZATION
            "
          >
            <b-alert show variant="info">
              Agora com seu cadastro na
              <a
                :disabled="isPermissionClerk"
                href="https://melhorenvio.com.br"
                target="_blank"
                rel="noopener noreferrer"
              >
                Melhor Envio
              </a>
              devidamente realizado é só autorizar a ConstrUp a ter acesso aos
              dados da sua loja.
              <div class="fs-14 mt-1">
                <i class="fas fa-info-circle mr-1"></i> Você será redirecionado
                para o site da Melhor Envio para confirmar a autorização, no
                site é só realizar seu login (caso não esteja logado) e clicar
                no botão "Autorizar".
              </div>

              <div class="mt-2">
                <b-btn :disabled="isPermissionClerk" size="sm" variant="success" @click="getAuthUrl()">
                  <i class="fas fa-clipboard-check mr-2"></i>
                  Autorizar acesso
                </b-btn>

                <b-btn
                  :disabled="isPermissionClerk"
                  v-if="gettingAuthUrl"
                  class="ml-2"
                  size="sm"
                  variant="info"
                  @click="get()"
                >
                  <i class="fas fa-check mr-2"></i>
                  Já autorizei
                </b-btn>
              </div>
            </b-alert>
          </b-col>
          <b-col
            cols="12"
            class="mt-4"
            v-if="
              fields.enabled &&
              fields.integration.status === ENABLED_INTEGRATION_STATUS.ACTIVE
            "
          >
            <b-alert show variant="success">
              Tudo certo com a sua integração com a
              <a
                href="https://melhorenvio.com.br"
                target="_blank"
                rel="noopener noreferrer"
                :disabled="isPermissionClerk"
              >
                Melhor Envio
              </a>
              agora é só vender pelo app!
            </b-alert>
            <div class="fs-14">
              <p>
                <strong>Integração iniciada em: </strong>
                {{ fields.integration.createdAt }}
              </p>
              <p>
                <strong>Integração autorizada em: </strong>
                {{ fields.integration.authorizedAt }}
              </p>
            </div>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>

    <b-popover
      v-if="showRegistryConfirmation"
      :show.sync="showRegistryConfirmation"
      target="confirmRegistryButton"
      title="Confirmação"
      triggers="click"
      placement="rightbottom"
      variant="info"
    >
      Sem o seu cadastro na Melhor Envio não será possível continuar para os
      próximos passos.

      <div class="mt-2 d-flex align-items-center">
        <b-button
          size="sm"
          variant="outline-danger"
          class="ml-auto mr-2"
          @click="showRegistryConfirmation = false"
          :disabled="isPermissionClerk"
        >
          <i class="fas fa-times mr-2"></i>
          Fechar
        </b-button>
        <b-button
        :disabled="isPermissionClerk"
          size="sm"
          variant="success"
          @click="
            () => {
              showRegistryConfirmation = false;
              update({
                status: ENABLED_INTEGRATION_STATUS.WAITING_AUTHORIZATION,
              });
            }
          "
        >
          <i class="fas fa-check mr-2"></i>
          Já fiz meu cadastro
        </b-button>
      </div>
    </b-popover>
  </b-overlay>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import makeToast from 'Mixins/makeToast';

import ENABLED_INTEGRATION_STATUS, {
  getText,
} from 'Enums/Integration/EnabledIntegrationStatus.js';
import PageTitle from '@/components/PageTitle.vue';

export default {
  name: 'MelhorEnvioConfiguration',
  mixins: [makeToast],
  components: {
    PageTitle
  },

  props: {
    isPermissionClerk: {
      type: Boolean,
      required: false,
      default: false
    },
  },

  data() {
    return {
      ENABLED_INTEGRATION_STATUS,
      loading: false,
      showRegistryConfirmation: false,
      gettingAuthUrl: false,
      fields: {
        enabled: false,
        integration: {
          id: '',
          status: 0,
          createdAt: '',
          updatedAt: '',
          authorizedAt: '',
        },
      },
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  mounted() {
    this.get();
  },
  methods: {
    getText,
    ...mapActions('integration', [
      'getMelhorEnvioEnabledIntegration',
      'updateMelhorEnvioEnabledIntegrationStatus',
      'saveMelhorEnvioEnabledIntegration',
      'getMelhorEnvioAuthUrl',
    ]),
    save() {
      this.loading = true;

      this.saveMelhorEnvioEnabledIntegration({
        construpUserId: this.dadosUsuario.id,
        status: ENABLED_INTEGRATION_STATUS.WAITING_USER_ACTION,
      })
        .then(() => {
          this.get();
        })
        .catch(() => {
          this.loading = false;

          this.makeToast(
            'Erro',
            'Houve um erro ao salvar seus dados',
            'danger'
          );
        });
    },
    update({ status }) {
      this.loading = true;

      this.updateMelhorEnvioEnabledIntegrationStatus({
        construpUserId: this.dadosUsuario.id,
        status:
          status ||
          (this.fields.enabled
            ? ENABLED_INTEGRATION_STATUS.ACTIVE
            : ENABLED_INTEGRATION_STATUS.DISABLED),
      })
        .then(() => {
          this.get();
        })
        .catch(() => {
          this.loading = false;

          this.makeToast(
            'Erro',
            'Houve um erro ao salvar seus dados',
            'danger'
          );
        });
    },
    get() {
      this.loading = true;

      this.getMelhorEnvioEnabledIntegration({
        construpUserId: this.dadosUsuario.id,
      })
        .then((response) => {
          const { id, status, createdAt, updatedAt, authorizedAt } =
            response.data.data || {};

          this.fields.integration.id = id;
          this.fields.integration.status = status;
          this.fields.integration.createdAt = createdAt;
          this.fields.integration.updatedAt = updatedAt;
          this.fields.integration.authorizedAt = authorizedAt;

          this.fields.enabled =
            id &&
            status !== ENABLED_INTEGRATION_STATUS.DISABLED &&
            status !== ENABLED_INTEGRATION_STATUS.INACTIVE;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getAuthUrl() {
      this.loading = true;

      this.getMelhorEnvioAuthUrl({
        construpUserId: this.dadosUsuario.id,
      })
        .then((response) => {
          this.gettingAuthUrl = true;

          const { authUrl } = response.data.data || {};

          window.open(authUrl, '_blank');
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>